const ACCOUNT_ID_WITH_CARD_ID_RE = /^[^-]+-[^-]+$/;

function isAccountIdWithCardId(id: string): boolean {
    return ACCOUNT_ID_WITH_CARD_ID_RE.test(id);
}

function parseCardId(id: string): string {
    const split = id.split('-');

    return split.pop() ?? '-';
}

export function parseProductId(productId?: string): string | undefined {
    if (!productId) {
        return undefined;
    }

    if (isAccountIdWithCardId(productId)) {
        return parseCardId(productId);
    }

    return productId;
}
